"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSetNewPasswordValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_1 = require("@framework/yup-rules");
const createSetNewPasswordValidationSchema = (policy) => (0, yup_1.object)().shape({
    login: (0, yup_1.string)().required("form.validations.valueMissing"),
    currentPassword: (0, yup_1.string)().required("form.validations.valueMissing"),
    newPassword: (0, yup_rules_1.createPasswordValidationSchema)(policy, { checkNotSameAsCurrent: true }),
    confirmPassword: (0, yup_1.string)()
        .required("form.validations.valueMissing")
        .oneOf([(0, yup_1.ref)("newPassword")], "form.validations.passwordsMustMatch"),
});
exports.createSetNewPasswordValidationSchema = createSetNewPasswordValidationSchema;
//# sourceMappingURL=validation.js.map